import { GenIcon } from '../helpers/IconBase.es.js';

const EmptySearchColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 226 176", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_1145_1221)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M190.936 176C246.3 136.539 228.01 20.5436 182.945 4.94584C126.599 -14.5559 116.568 28.7121 64.6473 46.5736C-44.0447 83.9647 13.0059 172.842 31.7438 176H190.936Z",
              fill: "#E4E5F0"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M190.936 176C246.3 136.539 228.01 20.5436 182.945 4.94584C126.599 -14.5559 116.568 28.7121 64.6473 46.5736C-44.0447 83.9647 13.0059 172.842 31.7438 176H190.936Z",
              fill: "#E4E5F0"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M141.921 31.9412L141.758 16.9936L114.206 17.3218C107.628 22.1474 100.84 27.445 93.0996 32.4733L141.921 31.9412Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M2.9696 97.9789H141.377V83.0302H10.3903C7.06135 87.9147 4.6357 92.9302 2.9696 97.9789Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M17.6116 165.009H141.377V150.06H8.13745C10.9643 155.819 14.2686 160.9 17.6116 165.009Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M83.8059 54.5392H61.9492V83.0301H83.8059V54.5392Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M60.0686 64.3072H38.2119V83.0291H60.0686V64.3072Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M106.603 121.668H84.7467V150.159H106.603V121.668Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M82.866 131.437H61.0094V150.159H82.866V131.437Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M59.015 131.437H37.1583V150.159H59.015V131.437Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M141.51 176H154.275V0.057951C149.709 0.263933 145.493 1.0192 141.51 2.20575V176Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M142.7 116.085C164.314 116.085 181.836 98.5629 181.836 76.9483C181.836 55.3338 164.314 37.8117 142.7 37.8117C121.085 37.8117 103.563 55.3338 103.563 76.9483C103.563 98.5629 121.085 116.085 142.7 116.085Z",
              fill: "white"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M107.423 130.236L119.292 113.688L129.296 118.23L113.524 140.788L101.507 148.639L107.423 130.236Z",
              fill: "#82869E"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M117.724 116.153L114.945 120.008L120.977 129.766L128.872 118.645C128.872 118.644 120.131 112.816 117.724 116.153Z",
              fill: "#434657"
            }
          },
          {
            tag: "path",
            attr: {
              opacity: "0.5",
              d: "M143.165 39.5175C142.334 39.5175 141.509 39.5443 140.691 39.5979C160.249 40.8714 175.719 57.1397 175.719 77.0191C175.719 96.8996 160.25 113.167 140.691 114.44C141.509 114.494 142.334 114.521 143.165 114.521C163.877 114.521 180.667 97.7311 180.667 77.0191C180.667 56.3072 163.877 39.5175 143.165 39.5175Z",
              fill: "#E4E5F0"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M143.165 30.554C142.336 30.554 141.511 30.5755 140.691 30.6184C116.18 31.9037 96.7001 52.1875 96.7001 77.0191C96.7001 101.851 116.179 122.133 140.691 123.419C141.511 123.462 142.335 123.483 143.165 123.483C168.827 123.483 189.63 102.68 189.63 77.0191C189.63 51.3582 168.826 30.554 143.165 30.554ZM105.662 77.0191C105.662 57.1386 121.132 40.8714 140.691 39.5979C141.509 39.5443 142.334 39.5175 143.165 39.5175C163.877 39.5175 180.667 56.3072 180.667 77.0191C180.667 97.731 163.877 114.521 143.165 114.521C142.334 114.521 141.509 114.494 140.691 114.44C121.133 113.167 105.662 96.8996 105.662 77.0191Z",
              fill: "#82869E"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M121.788 88.3889C121.063 88.0821 120.624 87.4845 120.471 86.5994C120.317 85.7122 120.416 84.8561 120.766 84.029C122.009 81.0948 128.539 78.3151 140.359 75.692C140.002 75.1857 139.469 74.4272 138.758 73.4166C137.564 71.6228 135.721 68.9118 133.229 65.2824C132.557 64.4649 131.574 63.228 130.283 61.5715C129.573 60.5599 129.454 59.4903 129.933 58.3616C131.128 55.5401 132.295 54.3707 133.435 54.8535C134.263 55.2043 135.209 56.6698 136.273 59.251C136.586 60.0492 138.144 62.7828 140.949 67.4549C143.752 72.126 145.275 74.513 145.517 74.616C145.828 74.748 148.756 74.0356 154.299 72.4811C159.843 70.9255 163.098 70.3526 164.065 70.7624C164.859 71.0982 165.374 71.6604 165.61 72.4489C165.846 73.2363 165.773 74.0817 165.39 74.9851C164.641 76.7531 163.163 77.9235 160.958 78.4975C159.551 78.9212 157.374 79.1412 154.424 79.1562C151.474 79.1712 149.542 79.2935 148.626 79.5274C151.226 84.0011 153.558 87.5628 155.623 90.2127C157.368 92.4603 157.929 94.3184 157.308 95.785C156.99 96.537 156.45 97.0402 155.69 97.2955C154.931 97.5498 154.173 97.5616 153.416 97.3298L143.133 80.5262C140.249 80.9896 136.92 81.687 133.148 82.6182C127.784 83.9388 124.92 85.032 124.553 85.8978C124.457 86.1231 124.355 86.4353 124.248 86.8333C124.141 87.2303 124.047 87.5242 123.967 87.713C123.584 88.6174 122.857 88.8416 121.788 88.3889Z",
              fill: "#BCBFD6"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M117.048 167.866C115.926 164.66 117.53 160.655 118.651 157.993C119.772 155.331 116.568 149.523 116.568 149.523C116.742 149.337 116.91 149.155 117.074 148.973C124.411 140.938 125.697 138.236 122.176 132.615C119.55 128.423 104.712 138.543 104.712 138.543C107.435 135.339 109.042 126.478 105.662 127.488C101.506 128.728 94.0631 136.625 85.4848 139.494C77.0739 142.307 60.6479 168.798 55.9103 175.998H117.514C118.529 173.482 117.943 170.419 117.048 167.866Z",
              fill: "#FFAA8E"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M117.342 176C118.357 173.483 117.771 170.42 116.877 167.866C115.755 164.66 117.358 160.655 118.479 157.994C119.601 155.332 116.396 149.524 116.396 149.524C116.57 149.338 116.738 149.156 116.902 148.974L115.823 149.912L111.325 153.488C111.137 154.704 112.803 168.648 111.857 176H117.342Z",
              fill: "#FA9373"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M79.1948 154.249C79.1948 154.249 80.2623 152.076 83.3488 149.523C86.4342 146.97 94.1457 141.423 98.1581 139.83C102.171 138.237 105.24 137.476 105.24 137.476L104.401 138.546C104.401 138.544 85.8828 149.685 79.1948 154.249Z",
              fill: "#FA9373"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M116.568 149.524C116.247 149.992 115.873 150.391 115.485 150.773C115.096 151.151 114.685 151.504 114.259 151.835C113.832 152.165 113.388 152.473 112.923 152.755C112.457 153.034 111.976 153.296 111.442 153.488C111.763 153.019 112.136 152.62 112.523 152.238C112.914 151.859 113.324 151.506 113.75 151.177C114.179 150.847 114.623 150.539 115.087 150.258C115.554 149.978 116.035 149.716 116.568 149.524Z",
              fill: "#E28166"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M120.05 133.522C120.277 133.649 120.475 133.808 120.664 133.974C120.852 134.143 121.025 134.324 121.187 134.516C121.511 134.899 121.788 135.323 122.011 135.777C122.233 136.23 122.4 136.72 122.48 137.227C122.518 137.481 122.536 137.74 122.522 137.997C122.505 138.255 122.463 138.512 122.371 138.754C122.282 138.509 122.203 138.281 122.117 138.057C122.031 137.834 121.942 137.619 121.85 137.404C121.665 136.977 121.467 136.56 121.264 136.141L120.641 134.872C120.436 134.44 120.229 134.004 120.05 133.522Z",
              fill: "#E28166"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M101.017 130.208C102.433 129.03 105.545 127.542 105.545 127.542C105.545 127.542 106.65 126.684 106.098 129.326C106.088 129.331 106.083 129.34 106.074 129.346L102.829 131.554C102.554 131.741 102.249 131.961 101.931 132.193C101.885 132.227 101.839 132.261 101.793 132.295C101.468 132.535 101.133 132.789 100.791 133.054L100.79 133.052C100.592 133.205 100.394 133.364 100.195 133.522C100.092 132.502 100.114 130.96 101.017 130.208Z",
              fill: "#FFD7B6"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_1145_1221" },
            child: [
              {
                tag: "rect",
                attr: { width: "225.234", height: "176", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { EmptySearchColored };
